import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconScratchCard: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconScratchCard"><Path fillRule="evenodd" clipRule="evenodd" d="M22 4H2V20H22V4ZM11.3197 7.77592L11.7324 8.81346L16.2694 8.01145L16.7198 9.42841L11.1067 12.0743L15.572 11.506L16.0394 12.9008L14.1868 13.9618L18.0711 13.1062L18.3938 14.5711L9.7169 16.4824L9.18281 15.0992L12.0292 13.469L6.59469 14.1607L6.18021 12.7383L11.0005 10.4661L6.63055 11.2386L6.22282 9.8031L11.3197 7.77592Z" fill="currentColor"/></CentralIconBase>;
});

export default IconScratchCard;
